import type { ComponentProps } from "react";

import { controlClass, controlHeight } from "@/components/ui/field";
import { cn } from "@/utils/utils";

/**
 * A number and the unit it is counted in, in one shell.
 *
 * The unit is furniture, not a field: it wears the disabled treatment — inset
 * fill, dimmed text, a cursor that refuses — so the only part that looks
 * typeable is the part that is. The focus ring belongs to the shell, so the
 * pair lights up together.
 */
export function UnitInput({
  unit,
  className,
  inputClassName,
  ...props
}: ComponentProps<"input"> & { unit: string; inputClassName?: string }) {
  return (
    <span
      className={cn(
        controlClass,
        controlHeight.md,
        "focus-within:border-accent focus-within:ring-[3px] focus-within:ring-[var(--accent-ring)]",
        "flex items-stretch overflow-hidden p-0",
        className,
      )}
    >
      <input
        {...props}
        className={cn(
          "bg-surface-raised text-fg placeholder:text-fg-subtle min-w-0 flex-1 [appearance:textfield] px-3 outline-none",
          "[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
          inputClassName,
        )}
      />
      <span className="border-line-strong bg-surface-inset text-fg-subtle text-footnote flex cursor-not-allowed items-center border-l px-2 select-none">
        {unit}
      </span>
    </span>
  );
}
